/* PawLi — client-side background removal via @imgly/background-removal (WebAssembly, 100% local processing, no paid API).
   Exposes window.removeBackground(file, onProgress) -> Promise<Blob> (transparent PNG).

   Import URL: loaded from esm.sh. (The package has no dist/browser/index.js; the bare
   dist/index.mjs has unresolved bare specifiers; and jsDelivr's "+esm" bundle is broken for
   this package — its lodash@~4.17 range build does not expose the named 'memoize' export,
   so the import throws a SyntaxError. esm.sh does proper CJS->ESM named-export analysis.)

   DSGVO / self-hosting:
   The image is processed entirely in the visitor's browser (nothing is uploaded).
   The only external request is downloading the model/runtime (42 MB) the first time,
   from imgly's data CDN by default. That model is too large for Shopify (per-file limit
   ~20 MB + flat namespace), so for zero external requests host the
   '@imgly/background-removal-data' dist on your OWN domain/CDN and set:
       window.PAWLI_IMGLY_PUBLIC_PATH = 'https://your-domain.tld/imgly-data/dist/';
   Optional overrides: window.PAWLI_IMGLY_MODULE_URL, window.PAWLI_IMGLY_MODEL ('small'|'medium'),
   window.PAWLI_IMGLY_PROXY_WORKER (true/false). Defaults work out of the box. */
(function () {
  const DEFAULT_MODULE = 'https://esm.sh/@imgly/background-removal@1.4.5';
  const MODULE_URL = window.PAWLI_IMGLY_MODULE_URL || DEFAULT_MODULE;
  const PUBLIC_PATH = window.PAWLI_IMGLY_PUBLIC_PATH || null; // set for full self-hosting
  const MODEL = window.PAWLI_IMGLY_MODEL || 'small';          // 'small' (42MB) is lighter/faster than 'medium'
  const PROXY_WORKER = (typeof window.PAWLI_IMGLY_PROXY_WORKER === 'boolean') ? window.PAWLI_IMGLY_PROXY_WORKER : false; // false = run ORT on main thread (reliable via CDN); avoids the ort-wasm-proxy-worker that fails in a bundled cross-origin context

  let modPromise = null;
  function loadModule() {
    if (!modPromise) {
      modPromise = import(/* @vite-ignore */ MODULE_URL).catch((err) => {
        console.error('[PawLi] imgly module import failed from', MODULE_URL, err);
        modPromise = null; // allow a retry on the next attempt
        throw err;
      });
    }
    return modPromise;
  }

  window.removeBackground = async function (file, onProgress) {
    const mod = await loadModule();
    const fn = mod.removeBackground || (mod.default && mod.default.removeBackground) || mod.default;
    if (typeof fn !== 'function') throw new Error('[PawLi] removeBackground export not found on imgly module');
    const config = {
      model: MODEL,
      proxyToWorker: PROXY_WORKER,
      output: { format: 'image/png' },
      progress: (key, current, total) => {
        if (typeof onProgress === 'function') onProgress(total ? Math.round((current / total) * 100) : 0, key);
      },
    };
    if (PUBLIC_PATH) config.publicPath = PUBLIC_PATH;
    try {
      return await fn(file, config); // transparent PNG Blob
    } catch (err) {
      console.error('[PawLi] imgly error:', err);
      throw err;
    }
  };

  // Warm-up so the model downloads while the user is still choosing/uploading.
  window.pawliPreloadBgRemoval = function () { loadModule().catch(() => {}); };
})();
